import isEmpty from 'lodash-es/isEmpty'
import React from 'react'

import { Dashboard } from '@components/common'
import type { EmptyStateProps } from '@fourthwall/components'
import { HeadContent, Pagination, usePagination } from '@fourthwall/components'

import { GiftCardsData } from '../../components/GiftCardsData/GiftCardsData'
import { useGiftCards } from '../../hooks/useGiftCards'

type GiftCardsListProps = {
  emptyStateProps: EmptyStateProps
}

export const GiftCardsList = ({ emptyStateProps }: GiftCardsListProps) => {
  const [currentPage, setCurrentPage] = usePagination()

  const paginatedProps = useGiftCards()

  return (
    <>
      <HeadContent title="Gift cards" />
      <Dashboard.Section.Item>
        <GiftCardsData
          data={paginatedProps.data || []}
          isLoading={paginatedProps.isLoading}
          emptyStateProps={emptyStateProps}
        />
      </Dashboard.Section.Item>
      {!isEmpty(paginatedProps.data) && paginatedProps.totalPages > 0 && (
        <Dashboard.Section.Item>
          <Pagination
            pageCount={paginatedProps.totalPages}
            currentPage={currentPage}
            onChange={setCurrentPage}
          />
        </Dashboard.Section.Item>
      )}
    </>
  )
}
